export default "__VITE_ASSET__CNF6b9xV__"